import type { FC } from 'react'

import {
  AddingFilesAttributeModal,
  AddingFilesFaultModal,
  AddingFilesHorizonModal,
  AddingFilesMapModal,
  AddingFilesModes,
  AddingFilesPolygonModal,
  AddingFilesSurvey2dModal,
  AddingFilesVSPModal,
} from '../AddingFilesModal'
import type { AddingFilesModalSelectorProps } from './types'

const AddingFilesModalSelector: FC<AddingFilesModalSelectorProps> = ({
  objectTreeNodeModal,
  uploadFiles,
  uploadMode,
}) => {
  switch (uploadMode) {
    case 'Survey3D':
      return <AddingFilesAttributeModal files={uploadFiles} treeObject={objectTreeNodeModal} />
    case 'Horizon':
      return (
        <AddingFilesHorizonModal
          files={uploadFiles}
          treeObject={objectTreeNodeModal}
          mode={AddingFilesModes.NxN}
        />
      )
    case 'Fault':
      return <AddingFilesFaultModal files={uploadFiles} treeObject={null} />
    case 'Survey2D':
      return <AddingFilesSurvey2dModal files={uploadFiles} treeObject={objectTreeNodeModal} />
    case 'Maps':
      return <AddingFilesMapModal files={uploadFiles} treeObject={objectTreeNodeModal} />
    case 'VSP':
      return <AddingFilesVSPModal files={uploadFiles} treeObject={objectTreeNodeModal} />
    case 'Polygons':
      return <AddingFilesPolygonModal files={uploadFiles} treeObject={null} />
    default:
      return null
  }
}

export { AddingFilesModalSelector }
